import React, { FC } from 'react';

import useIsMobile from '../../../../../hooks/useIsMobile';
import translate from '../../../../../i18n/translate';

import SearchList, { SearchListProps } from '../SearchList';
import { getHeadingTranslationKey } from '../helpers';

import * as Styled from './styled';

type Props = SearchListProps;

/**
 * Search checkbox list with heading
 *
 * @param props               Props passed to the component
 * @param props.dataSelected  IDs of the items already selected
 * @param props.isLoading     Whether the data is being loaded
 * @param props.isSearching   Whether something was typed into search
 * @param props.itemsFiltered Filtered items after search
 * @param props.onChange      When checkbox is toggled
 * @param props.type          Whether the list is for members/groups/labels
 * @returns                   The component itself
 */
const TabSearchGroup: FC<Props> = props => {
  const isMobile = useIsMobile();
  const headingTranslationKey = getHeadingTranslationKey(props.type);

  return (
    <>
      {headingTranslationKey !== null && !isMobile && (
        <Styled.SectionHeading>
          {translate(headingTranslationKey)}
        </Styled.SectionHeading>
      )}
      <SearchList {...props} />
    </>
  );
};

export default TabSearchGroup;
